import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import quotingActions from '../../quoting/quotingActions';
import userActions from '../../user/userActions';

import { Label, TextInput } from '../../components/forms';
import { IconCheck, IconErrorOutline } from '../../components/icons';
import Utils, { PolicyStatus } from '../../common/utils';

interface Props {
	validReferral: boolean;
	referrals: CustomerReferralResponse;
	user: UserDetails;
	policies: CustomerPolicy[];
	actions: any;
}
class AdminValidateReferralCode extends React.Component<Props> {
	validateReferralDebounced = Utils.debounce(() => {
		this.validateReferral(this.props.referrals.referralCode);
	});
	constructor(props: Props) {
		super(props);
	}

	componentDidMount() {
		this.validateReferral(this.props.referrals.referralCode);
	}

	checkExistingPolicy() {
		return this.props.policies.some(p => p.customerId === this.props.user.userId &&
			p.isActive! && p.statusId! === PolicyStatus.Active);
	}

	onValidateReferral = (e: any) => {
		this.props.actions.setReferralCode(e.target.value);
		this.validateReferralDebounced();
	}
	validateReferral = (referralCode?: string) => {
		if (referralCode != null) {
			this.props.actions.validateReferralCode(referralCode, this.props.user.id);
		}
	}

	render() {
		return (			
			!this.checkExistingPolicy() &&
			(
				<div className="mt-4">
					<h2 className="form-fieldset-title">Referral code</h2>
					<div className="form-fieldset">
						<div className="row">
							<div className="col-lg-8 form-group mb-0">
								<Label>Enter customer's referral code here if he or she has one</Label>
								<div className="position-relative">
									<TextInput
										name="remaining"
										placeholder="Enter referral code"
										value={this.props.referrals.referralCode}
										onChange={this.onValidateReferral}
										className="mb-0 enrollment-referral-field"
									/>
									{this.getReferralValidityMessage()}
								</div>
							</div>
						</div>
					</div>
				</div>
			)
		);
	}
	getReferralValidityMessage(): any {
		let msg;
		if (this.props.referrals.referralCode) {
			if (this.props.validReferral) {
				msg = <IconCheck className="enrollment-referral-icon text-success" />;
			}
			else {
				msg = (
							<div className="mt-1">
								<IconErrorOutline className="enrollment-referral-icon flush-right text-danger" /> 
								<span className="text-danger">The referral code is invalid</span>
							</div>);
			}
		}
		return msg;
	}
}
function mapStateToProps(state: any) {
	return {
		validReferral: state.quoting.validReferral,
		referrals: state.user.referrals,
		user: state.user.user,
		policies: state.policy.policies
	};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...quotingActions, ...userActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}
const connector = connect(mapStateToProps, mapDispatchToProps)(AdminValidateReferralCode);
export default connector;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/common/AdminValidateReferralCode.tsx